var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isMobile ? 'parentHistoryMobile' : 'parentHistory']},[_c('v-btn',{class:[_vm.isMobile ? 'historyButtonMobile' : 'historyButton'],attrs:{"color":"primary white--text","rounded":""},on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : "مشاهده سوابق")+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }